export enum EGarbageCanType {
    Waste = "Waste",
    Compost = "Compost",
    Recycling = "Recycling",
}

export type EGarbageCanTypeKeysType = keyof typeof EGarbageCanType;
